var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    filter: "drop-shadow(1.2px 1px 0.5px black)",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.87 0.87)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-144.89999999999998 -144.89999999999998) scale(3.22 3.22)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.718,
    cy: 73.438,
    r: 6.848,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.928,
    cy: 73.438,
    r: 6.848,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.209 25.922 c -1.348 0 -2.563 -0.935 -2.864 -2.306 l -0.542 -2.467 c -0.708 -3.225 -3.617 -5.565 -6.919 -5.565 h -2.95 C 1.314 15.583 0 14.269 0 12.649 s 1.314 -2.935 2.935 -2.935 h 2.95 c 6.037 0 11.357 4.28 12.651 10.176 l 0.542 2.467 c 0.348 1.583 -0.654 3.148 -2.237 3.496 C 16.629 25.9 16.417 25.922 16.209 25.922 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.166 73.837 c -0.005 -0.133 -0.02 -0.264 -0.02 -0.398 c 0 -2.025 0.619 -3.908 1.677 -5.471 H 41.825 c 1.058 1.563 1.677 3.446 1.677 5.471 c 0 0.134 -0.015 0.265 -0.02 0.398 H 60.166 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.937 73.438 c 0 -2.036 0.626 -3.927 1.695 -5.495 c -1.377 -0.121 -2.464 -1.267 -2.464 -2.674 c 0 -1.487 1.21 -2.698 2.698 -2.698 c 1.621 0 2.935 -1.314 2.935 -2.935 c 0 -1.621 -1.314 -2.935 -2.935 -2.935 c -4.725 0 -8.568 3.843 -8.568 8.567 c 0 4.063 2.846 7.468 6.648 8.343 C 23.945 73.554 23.937 73.497 23.937 73.438 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.903 70.902 L 83.903 70.902 c 0 -1.621 -1.314 -2.935 -2.935 -2.935 h -2.808 c 1.058 1.563 1.677 3.446 1.677 5.471 c 0 0.134 -0.015 0.265 -0.02 0.398 h 1.151 C 82.589 73.837 83.903 72.523 83.903 70.902 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.251 21.027 c -0.557 -0.621 -1.352 -0.976 -2.186 -0.976 H 16.211 c -0.889 0 -1.73 0.403 -2.287 1.095 c -0.557 0.693 -0.77 1.601 -0.579 2.469 l 8.043 36.651 c 0.295 1.346 1.488 2.305 2.866 2.305 h 53.688 c 4.965 0 8.139 -3.722 8.681 -8.658 l 3.359 -30.607 C 90.073 22.478 89.807 21.649 89.251 21.027 z M 61.201 44 H 56 v 5.201 c 0 1.657 -1.343 3 -3 3 s -3 -1.343 -3 -3 V 44 h -5.201 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 H 50 v -5.201 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 V 38 h 5.201 c 1.657 0 3 1.343 3 3 S 62.858 44 61.201 44 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.826d828fb886d2de350736c4200cf322.svg";
export { ForwardRef as ReactComponent };